import { logPageView } from './';
export var onRouteUpdate = function onRouteUpdate(_ref) {
  var location = _ref.location,
      prevLocation = _ref.prevLocation;
  var previousUrl = prevLocation && prevLocation.href ? prevLocation.href : null;
  logPageView(location.href, previousUrl);
};
export var onInitialClientRender = function onInitialClientRender(props, pluginOptions) {
  // Add the DEAnalytics configuration script to the page
  var script = document.createElement("script");
  script.innerHTML = configScript(pluginOptions, window.location.hostname);
  document.body.appendChild(script); // Add the Apollo Consent Manager script to the page

  loadScript(getScriptUrl(pluginOptions, window.location.hostname), false).then(function (data) {
    if (!window.DEAnalytics.ip) {
      window.DEAnalytics.init();
    }
  }).catch(function (err) {
    console.error(err);
  });
};
/**
 * Return a string of Javascript code that will be injected into the gatsby web page.
 * The passed options will be unique per site.
 */

var configScript = function configScript(pluginOptions, hostname) {
  return "\n    let DEAnalyticsInitData = {\n      'key': '".concat(getSegmentKey(pluginOptions, hostname), "',\n      'consentManager': true,\n      'consentPreferences': {\n        'Performance Cookies': true,\n        'Functional Cookies': true,\n        'Targeting Cookies': true,\n      },\n      'partnershipId': '").concat(pluginOptions.partnershipId, "',\n      'version': 4,\n      'regionTLD': '").concat(getRegionTopLevelDomain(getRegion(pluginOptions, window.location.hostname)), "'\n    };\n    ");
};
/**
 * @param {*} pluginOptions Plugin options declared in the configuration file
 * @param {*} hostname The current hostname. Ususally obtained from window.location.hostname
 * @returns
 */


var getSegmentKey = function getSegmentKey(pluginOptions, hostname) {
  var environment = getEnvironment(pluginOptions, hostname);

  if (environment === "PROD") {
    return pluginOptions.prodTrackingId || getSharedLegacySegmentKey(getRegion(pluginOptions, hostname), "PROD");
  } else if (environment === "STAGE") {
    return pluginOptions.stageTrackingId || getSharedLegacySegmentKey(getRegion(pluginOptions, hostname), "STAGE");
  } else {
    return pluginOptions.devTrackingId || getSharedLegacySegmentKey(getRegion(pluginOptions, hostname), "DEV");
  }
};
/**
 * Get the Legacy Segment key for the given region and environment.
 * More info here: https://discoveryed.atlassian.net/wiki/spaces/DB/pages/1789329853/Corporate+Education+Partnerships+CEP
 * @param {*} region The region to get the key for. "US" by default.
 * @param {*} environment It can either be "DEV", "STAGE", or "PROD". "DEV" by default.
 * @returns The leagacy Segment key for the given region and environment.
 */


var getSharedLegacySegmentKey = function getSharedLegacySegmentKey(region, environment) {
  if (environment === "PROD") {
    switch (region) {
      case "US":
        return "5seaYkvc7SCITVV9H8tJUYQ77OIYjTzS";

      case "CA":
        return "DwsH7rRd0ddwWAe5aeReVmHsp29ZlcBo";

      case "CO":
        return "BR87YwOuO1sL2vtjO7BNY1YAurBxhZVu";

      case "MX":
        return "cjcOte2SXTiwpetsFfCmHhktC9IYw2IH";

      case "UK":
        return "wADmvlIlErBjccOwjNs138oSQIuWS3PA";

      case "IE":
        return "8Y9EK0pHiMoLzseeA2gDxUVaMzokEJAQ";

      case "IN":
        return "uqB2IEUZYvmXFWImrVDaC8sKC5CNJXjr";

      default:
        return "5seaYkvc7SCITVV9H8tJUYQ77OIYjTzS";
    }
  } else if (environment === "STAGE") {
    switch (region) {
      case "US":
        return "F7GWwYsqIAzJxsU65zfgIKDmFYcIQmvD";

      case "CA":
        return "FsNLPj5nPlm3VjwfSu6mFoxUEjmrJIC9";

      default:
        return "F7GWwYsqIAzJxsU65zfgIKDmFYcIQmvD";
    }
  } else {
    switch (region) {
      case "US":
        return "a9U0PWohUAV2xuKP3FAi09iNt55vEaCM";

      case "CA":
        return "IOFdhxdaknfn75IpFfQVx024yJx9axxT";

      default:
        return "a9U0PWohUAV2xuKP3FAi09iNt55vEaCM";
    }
  }
};
/**
 * @returns A string representing the current date in the format YYYYMMDDHH
 */


var getFormattedDate = function getFormattedDate() {
  var date = new Date();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);
  var hours = ("0" + date.getHours()).slice(-2);
  return "".concat(date.getFullYear()).concat(month).concat(day).concat(hours);
};
/**
* @param {*} pluginOptions Plugin options declared in the configuration file
* @returns If there's a specific region declared for the domain and environment, return it.
* Otherwise, return the default region. If no region declared then return "US".
*/


var getRegion = function getRegion(pluginOptions, hostname) {
  var environment = getEnvironment(pluginOptions, hostname);

  if (environment === "DEV" && pluginOptions.extraDevHostnames) {
    // Check for objects in the array
    var objects = pluginOptions.extraDevHostnames.filter(function (devHostname) {
      return typeof devHostname === "object";
    }); // If there are objects in the array, check for a match

    if (objects.length > 0) {
      var objectMatch = objects.find(function (object) {
        return hostname.includes(object.domain);
      });

      if (objectMatch) {
        return objectMatch.region;
      }
    }

    return pluginOptions.region || "US";
  }

  if (environment === "STAGE" && pluginOptions.extraStageHostnames) {
    // Check for objects in the array
    var _objects = pluginOptions.extraStageHostnames.filter(function (stageHostname) {
      return typeof stageHostname === "object";
    }); // If there are objects in the array, check for a match


    if (_objects.length > 0) {
      var _objectMatch = _objects.find(function (object) {
        return hostname.includes(object.domain);
      });

      if (_objectMatch) {
        return _objectMatch.region;
      }
    }

    return pluginOptions.region || "US";
  }

  if (environment === "PROD" && pluginOptions.extraProdHostnames) {
    // Check for objects in the array
    var _objects2 = pluginOptions.extraProdHostnames.filter(function (prodHostname) {
      return typeof prodHostname === "object";
    }); // If there are objects in the array, check for a match


    if (_objects2.length > 0) {
      var _objectMatch2 = _objects2.find(function (object) {
        return hostname.includes(object.domain);
      });

      if (_objectMatch2) {
        return _objectMatch2.region;
      }
    }

    return pluginOptions.region || "US";
  }

  return pluginOptions.region || "US";
};
/**
* Parses the extra hostnames array and returns an array of strings
* @param {*} pluginOptions Plugin options declared in the configuration file
* @param {*} environment Can either be "DEV", "STAGE", or "PROD"
* @returns An array of strings containing the extra hostnames
*/


var getExtraHostNames = function getExtraHostNames(pluginOptions, environment) {
  var extraHostnames = null;

  switch (environment) {
    case "DEV":
      extraHostnames = pluginOptions.extraDevHostnames;
      break;

    case "STAGE":
      extraHostnames = pluginOptions.extraStageHostnames;
      break;

    case "PROD":
      extraHostnames = pluginOptions.extraProdHostnames;
      break;
  }

  if (!extraHostnames) {
    return null;
  }

  var extraHostnamesStrings = extraHostnames.filter(function (hostname) {
    return typeof hostname === "string";
  });
  var extraHostnamesObjects = extraHostnames.filter(function (hostname) {
    return typeof hostname === "object";
  });
  extraHostnamesObjects.forEach(function (element) {
    extraHostnamesStrings.push(element.domain);
  });
  return extraHostnamesStrings.length > 0 ? extraHostnamesStrings : null;
};
/**
* Gets the top level domain for the given region
* @param {String} region The region to get the top level domain for. It can be "US", "UK", or "CA"
* @returns Either ".com", ".co.uk", or ".ca"
*/


var getRegionTopLevelDomain = function getRegionTopLevelDomain(region) {
  switch (region) {
    case "US":
      return ".com";

    case "UK":
      return ".co.uk";

    case "CA":
      return ".ca";

    default:
      return ".com";
  }
};
/**
* Uses window.location to get and return the environment
* @param {*} pluginOptions Plugin options declared in the configuration file
* @param {*} hostname The current hostname. Ususally obtained from window.location.hostname
* @returns "DEV", "STAGE", or "PROD"
*/


var getEnvironment = function getEnvironment(pluginOptions, hostname) {
  var environment = "DEV";

  if (JSON.stringify(getExtraHostNames(pluginOptions, "DEV") || []).includes(hostname)) {
    environment = "DEV";
  } else if (JSON.stringify(getExtraHostNames(pluginOptions, "STAGE") || []).includes(hostname) || /^test-.*pantheonsite.io$/.test(hostname)) {
    environment = "STAGE";
  } else if (JSON.stringify(getExtraHostNames(pluginOptions, "PROD") || []).includes(hostname) || /^live-.*pantheonsite.io$/.test(hostname) || /^.*[.](org|com)$/.test(hostname) && !/^.*local.*$/.test(hostname) && !/^.*test.*$/.test(hostname) && !/^.*dev.*$/.test(hostname)) {
    environment = "PROD";
  }

  return environment;
};
/**
*  Load a script into the DOM. Returns a promise that resolves when the script is loaded.
* @param {String} FILE_URL The script's pathname
* @param {Boolean} async If true, the file will be loaded asynchronously. True by default.
* @param {String} type The content type of the script. "text/javascript" by default.
* @returns {Promise} A promise that resolves when the script is loaded.
*/


var loadScript = function loadScript(FILE_URL) {
  var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "text/javascript";
  return new Promise(function (resolve, reject) {
    try {
      var scriptEle = document.createElement("script");
      scriptEle.type = type;
      scriptEle.async = async;
      scriptEle.src = FILE_URL;
      scriptEle.addEventListener("load", function (ev) {
        console.log("Script loaded successfully");
        resolve({
          status: true
        });
      });
      scriptEle.addEventListener("error", function (ev) {
        reject({
          status: false,
          message: "Failed to load the script \uFF04{FILE_URL}"
        });
      });
      document.body.appendChild(scriptEle);
    } catch (error) {
      reject(error);
    }
  });
};
/**
* @param {*} pluginOptions Plugin options declared in the configuration file
* @param {*} hostname The current hostname. Ususally obtained from window.location.hostname
* @returns The script URL for the given environment
*/


var getScriptUrl = function getScriptUrl(pluginOptions, hostname) {
  var environment = getEnvironment(pluginOptions, hostname);
  var baseUrl = null;

  switch (environment) {
    case "PROD":
      baseUrl = "https://apollo.discoveryeducation";
      break;

    default:
      baseUrl = "https://apollo.dev.discoveryeducation";
  }

  return "".concat(baseUrl).concat(getRegionTopLevelDomain(getRegion(pluginOptions, hostname)), "/js/enterprise-analytics.min.js?key=").concat(getFormattedDate());
};